import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Path, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import type { ReportDefinition } from '../../../types';

export function LogoEditor() {
  const { control, setValue } = useFormContext<ReportDefinition>();
  const { $t } = useIntl();
  const logoUrl = useWatch({ control, name: 'data.branding.logoUrl' });
  const useClientLogo = logoUrl === null || logoUrl === undefined;

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        {$t({
          id: 'audit.reports.branding.logo',
          defaultMessage: 'Logo',
        })}
      </Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={useClientLogo}
              onChange={(e) => {
                const checked = e.target.checked;
                if (checked) {
                  setValue('data.branding.logoUrl' as Path<ReportDefinition>, null, {
                    shouldDirty: true,
                  });
                } else {
                  // When unchecking, set to empty string to show upload field
                  // The upload field will replace this when a file is uploaded
                  setValue('data.branding.logoUrl' as Path<ReportDefinition>, '', {
                    shouldDirty: true,
                  });
                }
              }}
            />
          }
          label={$t({
            id: 'audit.reportDefinitions.useClientLogo',
            defaultMessage: 'Usar logo del cliente',
          })}
        />
        {!useClientLogo && (
          <UploadAssetFieldMui
            name="data.branding.logoUrl"
            inputProps={{
              accept: 'image/*',
              label: $t({
                id: 'audit.reportDefinitions.loadCustomLogo',
                defaultMessage: 'Cargar logo personalizado',
              }),
              size: 'sm',
            }}
            assetLink
          />
        )}
      </Box>
    </Box>
  );
}
